import {Component, OnInit, signal} from '@angular/core';
import {ChecklistService} from '../../services/checklist.service';
import {Router, RouterLink} from '@angular/router';
import {ConfirmDialogService} from '../../services/confirm-dialog-service/confirm-dialog.service';
import {ChecklistCompleted} from '../../classes/checklist-completed';
import {Routenames} from '../../route-names.enum';
import {ChecklistChooseDialogComponent} from './checklist-choose-dialog/checklist-choose-dialog.component';
import {MatDialog} from '@angular/material/dialog';
import {SortingComponent} from '../../sorting.component';
import {VvrIconComponent} from "../../vvr-icon/vvr-icon.component";
import {MatTooltip} from "@angular/material/tooltip";
import {MatButton, MatIconButton} from "@angular/material/button";
import {MatCheckbox} from "@angular/material/checkbox";
import {FormsModule} from "@angular/forms";
import {SortingIconComponent} from "../../sorting-icon.component";
import {DatePipe} from "@angular/common";
import {MatRipple} from "@angular/material/core";

@Component({
    selector: 'app-checklist-overview',
    templateUrl: './checklist-overview.component.html',
    styleUrls: ['./checklist-overview.component.scss'],
    imports: [
        VvrIconComponent,
        RouterLink,
        MatTooltip,
        MatButton,
        MatCheckbox,
        FormsModule,
        SortingIconComponent,
        MatIconButton,
        DatePipe,
        MatRipple
    ]
})
export class ChecklistOverviewComponent extends SortingComponent<ChecklistCompleted> implements OnInit {

    readonly showAll = signal<boolean>(false);

    constructor(
        private checklistService: ChecklistService,
        private router: Router,
        private dialog: MatDialog,
        private confirmDialog: ConfirmDialogService) {
        super();
    }

    ngOnInit(): void {
        this.currentSort.update(() => 'created_at');
        this.getAnswers();
    }

    getAnswers() {
        this.subscriptions.add(
            this.checklistService.listAnswers(this.showAll()).subscribe(lists => {
                this.list.set(lists.data);
            })
        );
    }

    chooseChecklist() {
        this.dialog.open(ChecklistChooseDialogComponent, {
            width: '500px',
            maxHeight: '600px',
            panelClass: 'part-dialog',
            data: {}
        });
    }

    edit(checklist) {
        this.router.navigate([Routenames.checklistFillIn, checklist.checklist_id, {completedId: checklist.id}]);
    }

    delete(event, checklist: ChecklistCompleted) {
        event.stopPropagation();
        this.confirmDialog.confirm(
            'Inspectielijst intrekken',
            `Weet u zeker dat u de ingevulde inspectielijst '${checklist?.checklist?.name}' wilt verwijderen?`,
            'Verwijderen',
            'Behouden'
        ).then(() => {
            this.checklistService.deleteAnsweredChecklist(checklist.id).subscribe(() => {
                const index = this.list().indexOf(checklist);
                this.list().splice(index, 1);
            });
        }, () => {

        });
    }

    adTypeSortFunction = (item: ChecklistCompleted) => {
        return item?.checklist?.name;
    };

    inspectorSortFunction = (item: ChecklistCompleted) => {
        return item?.inspector?.name;
    };

    foremanSortFunction = (item: ChecklistCompleted) => {
        return item?.foreman?.name;
    };
}
